export const matKeys = {
	/**
	 * Material key for siding floor. Used to:
	 * 1. Adjusting UV scaling for the siding floor material.
	 * 2. Setting the material color when the outer joist is enabled.
	 * 3. Configuring the maxSimultaneousLights for DogKennel.
	 */
	sidingFloor: 'siding_floor_mat',

	/**
	 * Material key for transom black material. Used to:
	 * Set specularPower to 30 without changing diffuseColor.
	 */
	transomBlack: 'transom_black_mat',

	/**
	 * Material key for door metal vertical material. Used to:
	 * Set specularPower to 30 without changing diffuseColor.
	 */
	doorMetalVertical: 'door_metal_vertical_mat',

	/**
	 * Material key for door metallap slab material. Used to:
	 * Set specularPower to 3 without changing diffuseColor.
	 */
	doorMetallapSlab: 'door_metallap_slab_mat',

	/**
	 * Material key for Roof double S material. Used to:
	 * 1. Set specularPower to 3 without changing diffuseColor.
	 * 2. Adjusting UV scaling.
	 */
	roofDoubleS: 'roof_s_shape_mat',
	roofDoubleS01: 'roof_s_shape_cap_01_mat',
	roofDoubleS02: 'roof_s_shape_cap_02_mat',
	roofDoubleS03: 'roof_s_shape_cap_03_mat',

	/**
	 * Material key for Gable Roof Flat Tile materials. Used to:
	 * Adjusting UV scaling.
	 */
	roofRidgeCapMiddleFlatTile: 'roof_flat_tile_01_mat',
	roofRidgeCapLeftFlatTile: 'roof_flat_tile_02_mat',
	roofRidgeCapRightFlatTile: 'roof_flat_tile_03_mat',
	roofCoverLeftFlatTile: 'roof_flat_tile_04_mat',
	roofCoverRightFlatTile: 'roof_flat_tile_05_mat',

	/**
	 * Material key applied to the ceiling,
	 * Used to adjust UV scaling.
	 */
	ceilingMat: 'ceiling_mat',

	/**
	 * Material key applied to the roof polycabonate,
	 * Model: structure_aframe_single_gable
	 * Model version: structure_gardenshed_pergolaroof
	 * Used to Set specularPower to 179 without changing diffuseColor.
	 */
	roofPolycabonateMat: 'roof_polycabonate_mat',

	/**
	 * Material key applied to the siding polycabonate,
	 * Model: structure_aframe_single_gable
	 * Model version: structure_gardenshed_pergolaroof
	 * Used to Set specularPower to 179 without changing diffuseColor.
	 */
	sidingPolycabonateMat: 'siding_polycabonate_mat',

	/**
	 * Material key applied to the frame window material,
	 * Used to Set specularPower to 30 without changing diffuseColor.
	 */
	frameWindowMat: 'frame_window_mat',

	/**
	 * Material key applied to the frame transom material,
	 * Used to Set specularPower to 30 without changing diffuseColor.
	 */
	frameTransomMat: 'frame_transom_mat',
};
